import React, { useEffect, useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'

import ContentsDrawer from '../components/common/contents/ContentsDrawer'
import Layout from '../components/common/Layout'
import { MetaData } from '../components/common/meta'
import { FirebaseContext } from '../components/common/firebase'
import * as fitvids from "fitvids"
import RenegadeOSLiteController from "../components/index/renegadeOSLite/RenegadeOSLiteController"
import RenegadeOSLiteView from "../components/index/renegadeOSLite/RenegadeOSLiteView"
import IndexHeader from "../components/index/components/contents/IndexHeader"

/**
 * Single page (/:slug)
 *
 * This file renders a single page and loads all the content.
 *
 */
const Index = ({ data, location }) => {
    const page = data.ghostPage
    const logo = data.ghostSettings.logo;
    const allPosts = data.allGhostPost.edges;
    const [progress, setProgress] = useState(null)
    const [openContents, setOpenContents] = useState(false)

    useEffect(() => {
        fitvids()
    })

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="website"
            />
            <Helmet>
                <style type="text/css">{`${page.codeinjection_styles}`}</style>
            </Helmet>
            <Layout>
                <FirebaseContext.Consumer>
                    {({user, firebase, loading, loadingUserInfo}) => {

                        if (!loadingUserInfo || (!user && !loading)) {
                            return (
                                <ContentsDrawer
                                    logo={logo}
                                    allPosts={allPosts}
                                    post={page}
                                    showReadingProgress={false}
                                    displayHeading={false}
                                    progressBarValue={progress}
                                    openContents={openContents}
                                    isIndexPage={true}
                                    openLoginOnPageLoad={false}
                                    headerComponent={<IndexHeader />}
                                >
                                        <RenegadeOSLiteController
                                            html={page.html}
                                            allPosts={allPosts}
                                            dataScriptId="home_loggedOut"
                                            logo={logo}
                                            setProgressValue={(v) => {
                                                setProgress(v)
                                            }}
                                            setOpenContents={(v) => {
                                                setOpenContents(v)
                                            }}
                                        >
                                            {(data) => {
                                                return (
                                                    <RenegadeOSLiteView data={data}/>
                                                )
                                            }}
                                        </RenegadeOSLiteController>
                                </ContentsDrawer>
                            )
                        }
                    }}
                </FirebaseContext.Consumer>
            </Layout>
        </>
    )
}

Index.propTypes = {
    data: PropTypes.shape({
        ghostPage: PropTypes.shape({
            codeinjection_styles: PropTypes.object,
            title: PropTypes.string.isRequired,
            html: PropTypes.string,
            feature_image: PropTypes.string,
        }).isRequired,
    }).isRequired,
    location: PropTypes.object.isRequired,
}

export default Index

export const postQuery = graphql`
    query($slug: String!) {
        allGhostPost(sort: {order: ASC, fields: published_at}, filter: {primary_tag: {name: {eq: "story"}}}) {
            edges {
              node {
                id
                reading_time
                slug
                title
                visibility
              }
            }
        }
        ghostPage(slug: { eq: $slug }) {
            ...GhostPageFields
        }
        ghostSettings {
            logo
        }
    }
`
